/**
 * Chat header component with title and close button.
 */

import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

export interface ChatHeaderProps {
  onClose?: () => void;
}

export const ChatHeader: React.FC<ChatHeaderProps> = ({ onClose }) => {
  return (
    <Box
      sx={{
        bgcolor: 'white',
        borderBottom: '1px solid',
        borderColor: 'divider',
        p: 2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <Typography variant="h6SSemiBold" component="div" sx={{ color: 'text.primary' }}>
        AI Assistant
      </Typography>
      <IconButton
        size="small"
        onClick={onClose}
        sx={{ color: 'text.primary' }}
        aria-label="Close chat"
      >
        <CloseIcon />
      </IconButton>
    </Box>
  );
};

